var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2972 72.8307H73.3337H73.2972ZM73.2972 72.8307C70.9102 75.1978 66.5843 74.6082 63.5506 74.6082C59.8269 74.6082 58.0337 75.3366 55.376 77.9942C53.1132 80.2574 50.0795 84.3307 46.5003 84.3307C42.9211 84.3307 39.8874 80.2574 37.6245 77.9942C34.9669 75.3366 33.1737 74.6082 29.4499 74.6082C26.4163 74.6082 22.0903 75.1978 19.7034 72.8307C17.2973 70.4449 17.8894 66.1009 17.8894 63.0477C17.8894 59.1894 17.0456 57.4154 14.2979 54.6676C10.2107 50.5805 8.16707 48.5366 8.16699 45.9974C8.16703 43.4578 10.2106 41.4143 14.2978 37.327C16.7506 34.8743 17.8894 32.4438 17.8894 28.947C17.8894 25.9132 17.2999 21.5873 19.667 19.2002C22.053 16.7942 26.3968 17.3864 29.45 17.3864C32.9467 17.3864 35.3772 16.2477 37.8299 13.795C41.9172 9.70769 43.9607 7.66406 46.5003 7.66406C49.0399 7.66406 51.0835 9.70769 55.1706 13.795C57.6227 16.2472 60.0531 17.3864 63.5506 17.3864C66.5843 17.3864 70.9106 16.7969 73.2976 19.1641C75.7034 21.55 75.1112 25.8938 75.1112 28.947C75.1112 32.8053 75.9553 34.5793 78.7026 37.327C82.7901 41.4143 84.8337 43.4578 84.8337 45.9974C84.8337 48.5366 82.7901 50.5805 78.7026 54.6676C75.9549 57.4154 75.1112 59.1894 75.1112 63.0477C75.1112 66.1009 75.7034 70.4449 73.2972 72.8307Z",
    fill: "#0020F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49.4202C35 49.4202 39.6 51.9187 41.9 55.5807C41.9 55.5807 48.8 41.2057 58 36.4141",
    stroke: "white",
    strokeWidth: 5.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitCheckbox);
export default __webpack_public_path__ + "static/media/submit-checkbox.b9c52756553640962860b12c0e47f0eb.svg";
export { ForwardRef as ReactComponent };